export const config = {
  src: [
    'audiosprites/audio.ogg',
    'audiosprites/audio.mp3',
  ],
  sprite: {
    big_win: [
      0,
      6279.546485260771,
    ],
    button_spin: [
      8000,
      1391.7460317460311,
    ],
    end_free_spin: [
      11000,
      4915.374149659865,
    ],
    free_bet_big_win: [
      17000,
      1377.2335600907013,
    ],
    free_bet_mega_win: [
      20000,
      2213.151927437643,
    ],
    free_bet_total_win: [
      24000,
      979.591836734695,
    ],
    free_bet_ultra_win: [
      26000,
      1319.1836734693893,
    ],
    free_spin_ambient: [
      29000,
      26971.428571428576,
    ],
    free_spin_music: [
      57000,
      38402.90249433107,
    ],
    free_spin_popup: [
      97000,
      2317.6417233560046,
    ],
    free_spin_start: [
      101000,
      5707.755102040821,
    ],
    inside_buttons: [
      108000,
      384.5804988662138,
    ],
    main_ambient: [
      110000,
      63885.35147392289,
    ],
    main_music: [
      175000,
      148803.62811791385,
    ],
    mega_win: [
      325000,
      7704.6712018140515,
    ],
    outside_buttons: [
      334000,
      393.28798185943015,
    ],
    reel_spin: [
      336000,
      2345.2154195011303,
    ],
    reel_stop_01: [
      340000,
      445.532879818586,
    ],
    reel_stop_02: [
      342000,
      486.16780045352925,
    ],
    reel_stop_03: [
      344000,
      457.1428571428555,
    ],
    reel_stop_04: [
      346000,
      477.46031746032713,
    ],
    reel_stop_05: [
      348000,
      486.16780045352925,
    ],
    regular_win: [
      350000,
      2195.736961451246,
    ],
    tap_to_play: [
      354000,
      3371.247165532907,
    ],
    ultra_win: [
      359000,
      6330.340136054418,
    ],
  },
}
